import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';

class CharCounter extends Component {
  constructor() {
    super();
    this.isAllowedLength = this.isAllowedLength.bind(this);
    this.isTooLong = this.isTooLong.bind(this);
  }

  isTooLong() {
    const max = this.props.maxLength // If max length set, use that
      || (Number.isInteger(this.props.fixedLength) && this.props.fixedLength) // If fixed length is single number, use that
      || this.props.fixedLength.reduce((a, b) => // Else fixed length is an array Find highest length the field can be
        Math.max(a, b));
    return this.props.length > max;
  }

  isAllowedLength() {
    if (this.props.fixedLength) {
      if (Array.isArray(this.props.fixedLength)) {
        return this.props.fixedLength.includes(this.props.length);
      }
      return this.props.length === this.props.fixedLength;
    }
    return false;
  }

  render() {
    const shouldShow = this.props.fixedLength
      || (this.props.maxLength && (this.props.length > this.props.maxLength * 0.8));

    if (!shouldShow) {
      return null;
    }
  
    const maxLengthText = this.props.fixedLength ? ` ${this.props.translations['checkout.field.digits']}`
      : this.props.maxLength ? ` / ${this.props.maxLength}` : '';

    const className = this.isTooLong() ? 'charCounter_span-error' : '';

    return (
      <div className="charCounter">
        <span className={className}>{this.props.length}</span>
        {maxLengthText}
      </div>
    );
  }
}

CharCounter.propTypes = {
  desktopModifier: PropTypes.bool,
  length: PropTypes.number.isRequired,
  maxLength: PropTypes.number,
  fixedLength: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
};

const mapStateToProps = state => ({
  translations: state.lang,
});

export default connect(
  mapStateToProps,
)(CharCounter);
